import React, { useState, useEffect } from 'react';
import { lightStyles, darkStyles } from '../styles';

function Usage({ isDarkMode, usage, plan, handleCredGet }) {
    const styles = isDarkMode ? darkStyles : lightStyles
    const showPlan = typeof plan === 'string' && plan.length > 0
        ? plan.charAt(0).toUpperCase() + plan.slice(1)
        : plan;
    const [limits, setLimits] = useState({});

    useEffect(() => {
        setLimits({
            pro: 100000,
            business: 1000000,
            enterprise: 100000000
        });
    }, []);

    // Calculate the usage percentage
    const usagePercentage = (usage / limits[plan]) * 100;

    // Styles
    const progress = {
        progressBar: {
            marginTop: '20px',
            height: '50px',
            backgroundColor: isDarkMode ? '#111111' : '#f9fafb',
            borderRadius: '8px',
            overflow: 'hidden',
            border: `1px solid ${isDarkMode ? '#1a1a1a' : '#e5e7eb'}`,
            boxShadow: isDarkMode ? 'none' : 'inset 0 1px 2px rgba(15, 23, 42, 0.04)',
        },
        progress: {
            height: '100%',
            width: `${usagePercentage}%`,
            background: 'linear-gradient(135deg, #00d67a, #00b368)',
            borderRadius: '8px',
            textAlign: 'center',
            fontSize: '1rem',
            lineHeight: '50px',
            color: '#000000',
            fontWeight: '600',
            fontFamily: "'Inter', sans-serif",
            transition: 'width 0.3s ease',
        },
    };

    return (
            <div className="App" style={{ ...styles.body, paddingTop: "50px" }}>
                <h1 style={{marginTop: "50px"}}>Usage</h1>
                <div style={progress.progressBar}>
                    <div style={progress.progress}>{`${usagePercentage.toFixed(2)}%`}</div>
                </div>
                    <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>Plan: <strong>{showPlan}</strong></h3>
                    <p>You have used <strong>{usage}</strong> out of <strong>{limits[plan]}</strong> requests.</p>
                    <div>
                        <a href="#" onClick={(e) => { e.preventDefault(); handleCredGet(); }}>Refresh</a>
                    </div>
            </div>
    );
}

export default Usage;